
export const HEADER_VALUES = {
    BEARER: 'Bearer',
}

export const APPLICATION_TYPE = {
    JSON: 'application/json',
    PDF: 'application/pdf',
    CSV: 'application/octet-stream',
    EXCEL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    TEXT: 'text/plain',
    JPEG: 'image/jpeg',
    GIF: 'image/gif',
    PNG: 'image/png',
}

export const HEADERS = {
    AUTHORIZATION: 'Authorization',
    CONTENT_TYPE: 'Content-Type',
    ALLOW_ORIGIN: 'Access-Control-Allow-Origin'
}

export const DATE_FORMAT = {
    LOCAL: 'dd/MM/yyyy',
    LOCAL_INPUT_FIELD: 'yyyy-MM-dd'
}

export const REPLACEBLE_ITEMS = {
    TOASTER_MESSAGE: '${MESSAGE}',
    ID: '%{id}'
}

export const CONFIGURATIONS = {
    TOASTER_TIMEOUT: 3000,
    TOASTER_POSITION: 'toast-top-right',
    MaxFileSize: 15,
    FileTyesAllowed:['.pdf','.docx','.doc']
}

export const ADDRESS_TYPES = {
    BILLING_ADDRESS: 'B',
    DELIVERY_ADDRESS: 'D',
    PAYER: 'P'
}

export const CONTACT_TYPES = {
  PRIMARY_CONTACT: 'P',
  SECONDARY_CONTACT: 'S'
}

export const FILE_EXD = {
    CSV: '.csv',
    EXCEL: '.xlsx'
}

export const FILE_TYPE = {
    CSV: 'CSV',
    EXCEL: 'EXCEL'
}

export const PAGINATION_RECORDS_PER_PAGE = 10;

export const MESSAGES = {
  UPLOAD_SUCCESS: "Document has been uploaded successfully.",
  UPLOAD_FAILURE: "Unable to upload the document.",
  DOWNLOAD_SUCCESS: "Document has been downloaded successfully.",
  DOWNLOAD_FAILURE: "Unable to download the document."
};
